var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 79,
    viewBox: "0 0 52 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9709 35.3589C52.5657 37.4706 52.5657 41.433 49.9709 43.5447L8.85815 77.0046C5.41022 79.8107 0.249996 77.3572 0.249996 72.9117L0.249999 5.99194C0.249999 1.54643 5.41022 -0.907098 8.85815 1.89902L49.9709 35.3589Z",
    fill: "#FB5555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.fadfbaa66917eb7160d2563a8b5b77aa.svg";
export { ForwardRef as ReactComponent };